// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as SterlingTokens$LiveRoom from "../bindings/SterlingTokens.bs.js";
import * as StyleConstants$LiveRoom from "../styles/StyleConstants.bs.js";
import * as AnalyticsManager$LiveRoom from "../analytics/AnalyticsManager.bs.js";

function TestAuctionBanner(props) {
  React.useEffect((function () {
          AnalyticsManager$LiveRoom.disableAnalytics(undefined);
        }), []);
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.width(Css.pct(100)),
                    tl: {
                      hd: Css.padding2(Css.zero, Css.px(24)),
                      tl: {
                        hd: Css.background(Css.linearGradient(Css.deg(90), [
                                  [
                                    Css.pct(0),
                                    Css.hex(SterlingTokens$LiveRoom.Colors.alertOrange60_nohashtag)
                                  ],
                                  [
                                    Css.pct(100),
                                    Css.hex("7A6DC9")
                                  ]
                                ])),
                        tl: {
                          hd: Css.display(Css.flexBox),
                          tl: {
                            hd: Css.justifyContent(Css.center),
                            tl: {
                              hd: Css.alignItems(Css.center),
                              tl: /* [] */0
                            }
                          }
                        }
                      }
                    }
                  })
            }, React.createElement("p", {
                  className: Curry._1(Css.style, {
                        hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryWhite_nohashtag)),
                        tl: {
                          hd: Css.fontWeight({
                                NAME: "num",
                                VAL: StyleConstants$LiveRoom.medium
                              }),
                          tl: {
                            hd: Css.fontSize(Css.px(16)),
                            tl: {
                              hd: Css.lineHeight(Css.px(24)),
                              tl: {
                                hd: Css.textAlign(Css.center),
                                tl: /* [] */0
                              }
                            }
                          }
                        }
                      })
                }, "Test auction"));
}

var make = TestAuctionBanner;

export {
  make ,
}
/* Css Not a pure module */
